import { errorMessages } from "./errorMessage";
import { immediateToast } from "izitoast-react";

export const apiResponseToast = (
  status,
  component,
  error = "Invalid Information Sent"
) => {
  console.log("componente is here", component, status);
  switch (component) {
    case "athleteRegistration":
      switch (status) {
        case 400:
          showToast("warning", error, 100000000);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.athleteRegistration200);
          break;
        case 201:
          showToast("success", errorMessages.athleteRegistration201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "editUser":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.editUser200);
          break;
        case 201:
          showToast("success", errorMessages.eidtUser201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "joinGym":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.joinGym200);
          break;
        case 201:
          showToast("success", errorMessages.joinGym201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "joinTrack":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.joinTrack200);
          break;
        case 201:
          showToast("success", errorMessages.joinTrack201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "gymPersonalRegistraion":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.gymPersonalRegistraion200);
          break;
        case 201:
          showToast("success", errorMessages.gymPersonalRegistraion201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "gymCreation":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.gymCreation200);
          break;
        case 201:
          showToast("success", errorMessages.gymCreation201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "login":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.login200);
          break;
        case 201:
          showToast("success", errorMessages.login201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "forgotpassword":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.forgotpassword200);
          break;
        case 201:
          showToast("success", errorMessages.forgotpassword201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "resetpassword":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.resetpassword200);
          break;
        case 201:
          showToast("success", errorMessages.resetpassword201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "addTrack":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.addTrack200);
          break;
        case 201:
          showToast("success", errorMessages.addTrack201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "connectwithstripe":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          // showToast("success", errorMessages.connectwithstripe200);
          break;
        case 201:
          // showToast("success", errorMessages.connectwithstripe201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;

    case "subscribeWithStripe":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          // showToast("success", errorMessages.subscriptionwithstripe200);
          break;
        case 201:
          // showToast("success", errorMessages.subscriptionwithstripe201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "updateTrack":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.updateTrack200);
          break;
        case 201:
          showToast("success", errorMessages.updateTrack201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "removeTrack":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.removeTrack200);
          break;
        case 201:
          showToast("success", errorMessages.removeTrack201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "removeGym":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.removeGym200);
          break;
        case 201:
          showToast("success", errorMessages.removeGym201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "addWorkout":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.addWorkout200);
          break;
        case 201:
          showToast("success", errorMessages.addWorkout201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "removeWorkout":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.removeWorkout200);
          break;
        case 201:
          showToast("success", errorMessages.removeWorkout201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "editWorkout":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.editWorkout200);
          break;
        case 201:
          showToast("success", errorMessages.editWorkout201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "duplicateWorkout":
      switch (status) {
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.duplicateWorkout200);
          break;
        case 201:
          showToast("success", errorMessages.duplicateWorkout201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "addScore":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.addScore200);
          break;
        case 201:
          showToast("success", errorMessages.addScore201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "updateScore":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.updateScore200);
          break;
        case 201:
          showToast("success", errorMessages.updateScore201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "deleteScore":
      switch (status) {
        case 400:
          showToast("warning", error);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.deleteScore200);
          break;
        case 201:
          showToast("success", errorMessages.deleteScore201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "getathletes":
      switch (status) {
        case 400:
          showToast("warning", error, 100000000);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.getathletes200);
          break;
        case 201:
          showToast("success", errorMessages.getathletes201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "removeUser":
      switch (status) {
        case 400:
          showToast("warning", error, 100000000);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 200:
          showToast("success", errorMessages.removeUser200);
          break;
        case 201:
          showToast("success", errorMessages.removeUser201);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    case "exitGroup":
      switch (status) {
        case 400:
          showToast("warning", error, 100000000);
          break;
        case 401:
          showToast("warning", errorMessages.General_401);
          break;
        case 404:
          showToast("warning", errorMessages.General_404);
          break;
        case 500:
          showToast("warning", errorMessages.General_500);
          break;
        case 403:
          showToast("warning", errorMessages.forbidden);
          break;
        default:
          showToast("warning", errorMessages.General_Error);
          break;
      }
      break;
    default:
      showToast("warning", errorMessages.General_Error);
      break;
  }
};

const showToast = (type, message, time = 2500) => {
  immediateToast(type, {
    message: message,
    timeout: time,
    drag: true,
  });
};

const showDetialedToast = (type, title, content) => {
  immediateToast(type, {
    message: `<div><strong>${title}</strong></div><div>${content}</div>`,
  });
};

// apiResponseToast(400, "StripeMessage", {
//   title: "Huraahh",
//   message: "working",
// });
